const personal = {
    path: '/personal',
    name: 'personalfile',
    icon: 'iconpaper_plane_fill',
    component: () => import('@/pages/layout/appMain'),
    redirect: '/personal/material',
    children: [
        //修改个人资料
        {
            name: 'Personalinfo',
            icon: 'el-icon-user',
            path: '/material',
            component: () => import('@/pages/file/material')
        },
    ]
}
export default personal